import './css/index.css';
import 'components/pop-up-form';
import 'components/pop-up-success';
import { validateMCForm } from 'js/validate-mc-form';

const popUpForm = document.getElementById( 'pop-up-form' );
const popUpSuccess = document.getElementById( 'pop-up-success' );

const emailBtn = document.getElementById( 'email-btn' );
const closeBtns = document.querySelectorAll( '.pop-up-close' );

if ( emailBtn ) {

    emailBtn.addEventListener( 'click', () => {

        popUpForm.showModal();

    } );

}

closeBtns.forEach( ( closeBtn ) => {

    closeBtn.addEventListener( 'click', ( event ) => {

        popUpForm.close();
        popUpSuccess.close();

    } );

} );

const form = document.querySelector( '#mc-embedded-subscribe-form' );

if ( form ) {

    form.addEventListener( 'submit', async ( e ) => {

        const valid = validateMCForm( e );

        if ( valid ) {

            e.preventDefault();

            const formData = new FormData( form );

            fetch( 'https://philadelphiafed.us14.list-manage.com/subscribe/post?u=53cfdb83cc8c20a3a3aca6779&amp;id=49da8c279b&amp;f_id=0079b3e5f0', {
                method: 'POST',
                mode: 'no-cors',
                body: formData,
            } )
                .then( ( response ) => {

                    return response.text();

                } )
                .catch( ( error ) => {

                    console.error( 'Fetch error', error );

                } );

            popUpForm.close();
            popUpSuccess.showModal();
            form.reset();

        }

    } );

}
